'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00249 from "./presto.-Login-Page-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$8() {
  this.b8o = null;
  this.b8g = null;
  this.b8h = false;
  this.b8p = null;
  this.b8q = false;
  this.b8t = null;
  this.b8m = null;
  this.b8n = false;
  this.b8i = null;
  this.b8j = false;
  this.b8k = null;
  this.b8l = false;
  this.b8r = false;
  this.b8s = false;
  this.b8o = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b8t = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$8 as $c_Lpresto_LoginPageView$$anon$8 };
$p = $c_Lpresto_LoginPageView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$8;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$8() {
}
export { $h_Lpresto_LoginPageView$$anon$8 as $h_Lpresto_LoginPageView$$anon$8 };
$h_Lpresto_LoginPageView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b8o;
});
$p.M = (function() {
  if ((!this.b8h)) {
    this.b8g = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b8h = true;
  }
  return this.b8g;
});
$p.O = (function() {
  if ((!this.b8q)) {
    this.b8p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b8q = true;
  }
  return this.b8p;
});
$p.D = (function() {
  return this.b8t;
});
$p.t = (function() {
  if ((!this.b8n)) {
    this.b8m = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b8n = true;
  }
  return this.b8m;
});
$p.N = (function() {
  if ((!this.b8j)) {
    this.b8i = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b8j = true;
  }
  return this.b8i;
});
$p.Q = (function() {
  if ((!this.b8l)) {
    this.b8k = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00249.$c_Lpresto_LoginPageView$$anon$9();
    this.b8l = true;
  }
  return this.b8k;
});
$p.v = (function() {
  if ((!this.b8s)) {
    this.b8r = false;
    this.b8s = true;
  }
  return this.b8r;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee61) => ((p) => \u03b4scrutinee61.H3(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$8, "presto.LoginPageView$$anon$8", ({
  Mu: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$8 as $d_Lpresto_LoginPageView$$anon$8 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$8.js.map
